import React, { useState, useRef, useEffect } from "react";
import { Table, Input, Space, Button, Tabs, Spin, message, Form, Popconfirm, Typography, Modal, Popover, Select, DatePicker, Badge, Skeleton, Flex } from "antd";
import { BellTwoTone, CopyOutlined, EyeTwoTone, ReloadOutlined, SearchOutlined, SettingOutlined } from "@ant-design/icons";
import OrderEditModal from "./Woocommerce-orders-modal";
import CategoryBaseProducts from "./CatogoryBaseProducts";
import { format, parseISO, isSameDay, isValid } from "date-fns";
import dayjs from "dayjs";
import axiosApi from "../axiosApi/axiosApi";
import { createStyles } from 'antd-style';
import AddNewOrderToWooCommerce from "./addNewOrderToWooCommerce";
import CsvUploadModal from "./CsvModal";
import ExportProductsModal from "./CsvExportModal";
import SignInToHighLevel from "../gohighlevel/SignInToHighLevel";
import { uri } from "../backendUri";
import LogoutButton from "../gohighlevel/auth/logout";
import SettingModal from "./setting/setting";

import axios from 'axios';
// other imports
 

const { TabPane } = Tabs;
const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    const inputNode = <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[{ required: true, message: `Please Input ${title}!` }]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const useStyle = createStyles(({ css, token }) => {
    const { antCls } = token;
    return {
        customTable: css`
        ${antCls}-table {
          ${antCls}-table-container {
            ${antCls}-table-body,
            ${antCls}-table-content {
              scrollbar-width: thin;
              scrollbar-color: #eaeaea transparent;
              scrollbar-gutter: stable;
            }
          }
        }
      `,
    };
});

const conditions = {
    1: 'Good',
    2: 'Better',
    3: 'Best'
}

const columnFieldMap = [
    { label: 'Order ID', value: 'id' },
    { label: 'Date', value: 'date_created' },
    { label: 'Store Name', value: 'store_name' }, // Only if you store this manually
    { label: 'Product Name', value: 'name' }, // Inside line_items array
    { label: 'Customer Name', value: 'billing_name' }, // Custom field for combined name
    { label: 'Customer Email', value: 'billing.email' },
    { label: 'Payment Status', value: 'status' },
];

const statusOptions = ["auto-draft", "pending", "processing", "on-hold", "completed", "cancelled", "refunded", "failed",
    "checkout-draft",
    "wcf-main-order"
];

const CustomPage = () => {
    const [form] = Form.useForm();
    const [activeTab, setActiveTab] = useState("orders");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [orders, setOrders] = useState([]);
    const [ordersData, setOrdersData] = useState([]);
    const [reports, setReports] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState('name');
    const [editingKey, setEditingKey] = useState(false);
    const [orderToEdit, setOrderToEdit] = useState(null);
    const [openNewOrder, setOpenNewOrder] = useState(false);
    const searchInput = useRef(null);
    const [saveLoading, setSaveLoading] = useState(false);
    const [isCatogoryDevice, setIsCatogoryDevice] = useState(false);
    const [products, setProducts] = useState({})
    const [catogoriesData, setCatogoriesData] = useState([])
    const [slectedCaogory, setSlectedCaogory] = useState(null)
    const [globalSearchVal, setGlobalSearchVal] = useState('')
    const [searchedOrders, setSearchedOrders] = useState([]);
    const [rawProducts, setRowProducts] = useState([])
    const [productLoading, setProductLoading] = useState(false)
    const { styles } = useStyle()
    const [createOrderModal, setCreateOrderModal] = useState([])
    const [isCsvModal, setIsCsvModal] = useState(false)
    const [newOrdersCount, setNewOrdersCount] = useState(0);
    const [rowCatogories, setRowCatogories] = useState([])
    const [isCsvExportModal, setIsCsvExportModal] = useState(false)
   
    const [isViewKey, setIsViewKey] = useState(false);
    const [matchedReports, setMatchedReports] = useState([]);
    let pagination = { page: 1, pages: 0, count: 0 }
    const [searchTermForOrders, setSearchTermForOrders] = useState({ name: '' })
    const [searchTermForProducts, setSearchTermForProducts] = useState({ name: '' })
    const [paginationDetForProducts, setPaginationDetForProducts] = useState(pagination)
    const [paginationDetForOrders, setPaginationDetForOrders] = useState(pagination)
    const [isSettingModel, SetIsSettingModel] = useState(false);
    const isFetching = useRef(false);
    const isEditing = (record) => record.key === editingKey;





    useEffect(() => {
        const fetchOrdersCount = async () => {
            if (isFetching.current) return;
            isFetching.current = true;

            try {
                const { data } = await axiosApi.get("/fetch-orders-count");
                if (orders?.length) {
                    setNewOrdersCount(Number(data?.count) - orders.length);
                }
            } catch (error) {
                console.error("Error fetching order count:", error);
            } finally {
                isFetching.current = false;
            }
        };

        fetchOrdersCount();
        const interval = setInterval(fetchOrdersCount, 30000);

        return () => clearInterval(interval);
    }, [orders]);

    useEffect(() => {
        console.log(slectedCaogory);


        if (slectedCaogory) {
            setSearchTermForProducts({ 'categories': Number(slectedCaogory) })
            fetchProducts(0, { 'categories': Number(slectedCaogory) })
        } else {
            setCatogoriesData([])
        }


    }, [slectedCaogory])

    function handleGlobalSearch(val) {
        let currentTabItems = activeTab === 'inventory' ? products : orders;
        let filteredData = currentTabItems?.filter(item =>
            Object.values(item)?.some((value) => {
                if (value !== null && value !== undefined) {
                    return value.toString().toLowerCase().includes(val.toLowerCase());
                }
                return false;
            })
        );

        if (activeTab === 'inventory') {
            setCatogoriesData(filteredData); // Correctly updating categories
            // setProducts(filteredData); // Correctly updating categories
        } else {
            setSearchedOrders(filteredData); // Updating orders properly
        }
    }


    const fetchProducts = async (page = 1, searchBy) => {
        if (products[Number(page)]) {
            setPaginationDetForProducts({
                ...paginationDetForProducts,
                page: page
            })
            return false;
        }
        setProductLoading(true);
        try {
            let { data } = await axiosApi.get(`/fetchWommerce-products`, {
                params: {
                    page: page,
                    limit: 10,
                    searchBy
                }
            });

            const reportSkuCountMap = new Map();
            reports?.forEach((report) => {
                if (report?.sku && report.inStock?.toLowerCase() == 'yes') {
                    reportSkuCountMap.set(report.sku, (reportSkuCountMap.get(report.sku) || 0) + 1);
                }
            });

            const transformProducts = data.products.map((product) => {
                const cosmeticCondition = product?.attributes?.find(attr => attr?.slug === "pa_cosmetic-condition")?.option || "N/A";
                const isDeviceCategory = product?.categories?.some(cat => cat.name === "Devices");

                let stockQuantity = isDeviceCategory
                    ? reportSkuCountMap.get(product.sku) || 0
                    : product?.stock_quantity !== null ? product?.stock_quantity || 1 : "NA";

                return {
                    categories: product?.categories,
                    key: product.id,
                    productName: product?.productName || product?.name || "NA",
                    variationName: product?.name,
                    sku: product.sku || "NA",
                    description: product.description
                        ? product.description.replace(/<\/?[^>]+(>|$)/g, "")
                        : "NA",
                    brand: product?.brands?.length > 0 ? product.brands[0]?.name : "NA",
                    regularPrice: product.regular_price || "NA",
                    salePrice: product?.sale_price || "NA",
                    stockQuantity: stockQuantity,
                    stockStatus: stockQuantity === 0 ? 'out of Stock' : product?.stock_status,
                    condition: cosmeticCondition,
                    category: product.categories?.length > 0 ? product.categories[0].name
                        : product?.type === "variation" ? product?.type
                            : "NA",
                    link: product.permalink || "NA",
                    attributes: product?.attributes
                };
            });

            setRowProducts(data?.rawProducts);
            let finalPageNumber = page === 0 ? 1 : page
            let finalResult = finalPageNumber > 1 ? { ...products, [finalPageNumber]: transformProducts } : { [finalPageNumber]: transformProducts }
            setProducts(finalResult);
            setPaginationDetForProducts({ ...paginationDetForProducts, page: finalPageNumber, count: data?.total });

            message.success("Products fetched successfully!");
        } catch (error) {
            setError("Failed to fetch orders. Please try again later.");
            message.error("Failed to fetch Reports.");
        } finally {
            setProductLoading(false);
        }
    };



    const edit = (record) => {
        form.setFieldsValue({ ...record });
        setEditingKey(true);
        setOrderToEdit({ id: ordersData[record.key].id, report_link: '', ...ordersData[record.key] })
    };


    const viewReprots = (record) => {
        console.log(record);
        const matchingReport = reports?.filter((report, ind) => {
            return report?.sku == record?.sku && report?.inStock === "Yes"
        });

        const formatedReport = matchingReport?.map((report) => {
            debugger

            return {
                reportId: report?.reportId || "N/A",
                reportDate: report?.reportDate || "N/A",
                imei: report?.imei || "N/A",
                brand: report?.brand || "N/A",
                model: report?.model || "N/A",
                os: report?.os || "N/A",
                operator: report?.repor?.operator || "N/A",
                status: report ? "In stock" : "Out of stock",
                grade: conditions[report?.grade] || "N/A",
                ram: report?.ram || "N/A",
                storage: report.storage || "N/A",
                reportLink: `https://report.gearvu.io/report/${report?.reportId}`
            };
        })
        setMatchedReports(formatedReport)
        setIsViewKey(true);

    };

    const getColumnSearchProps = (dataIndex) => {
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={searchInput}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 250, marginBottom: 8, display: "block" }}

                    />
                    <Space>
                        <Button type="primary" style={{ background: "#1677ff", color: "white" }} onClick={() => handleSearch(selectedKeys, confirm, dataIndex)} icon={<SearchOutlined />} size="small">
                            Search
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} type="primary" style={{ background: "#1677ff", color: "white" }} size="small">
                            Reset
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
            onFilter: (value, record) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        }

    }

    function handleSearchFromSearchBar(searchVal) {
        setSearchText(searchVal);
    }

    const handleSearch = (selectedKeys, confirm, dataIndex, SearchValFromSearchBar = '') => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };

    const fetchOrders = async (page = 1, searchBy) => {
        if (orders[Number(page)]) {
            setPaginationDetForOrders({
                ...paginationDetForProducts,
                page: page
            })
            return false;
        }
        setLoading(true)
        try {
            // let { data } = await axios.get("http://gearvubackup.dymaxtech.com/api/fetchWommerce-orders");
            let { data } = await axiosApi.get("/fetchWommerce-orders", {
                params: {
                    page: page,
                    limit: 10,
                    searchBy
                }
            }
            );
            const transformedOrders = data?.orders?.map((order, index) => ({
                key: index.toString(),
                orderId: order.id || null,
                storeName: order?.store?.name || 'not found',
                productName: Array.isArray(order?.line_items) && order.line_items.length > 0 ? order.line_items[0]?.name || "" : "not found",
                customerName: `${order.billing.first_name || ''} ${order.billing.last_name || ''}`.trim() || null,
                customerEmail: order.billing.email || null,
                color: order.line_items?.map(item => item.color || 'N/A').join(", ") || null,
                reportLink: order.report_link || null,
                shippingAddress: `${order.shipping.address_1 || ''}, ${order.shipping.address_2 || ''}, ${order.shipping.city || ''}, ${order.shipping.state || ''}, ${order.shipping.postcode || ''}`.trim() || null,
                status: order.status || null,
                date_created: format(new Date(order.date_created), "MMMM dd, yyyy")
            }));

            let finalPageNumber = page === 0 ? 1 : page
            let finalResult = finalPageNumber > 1 ? { ...orders, [finalPageNumber]: transformedOrders } : { [finalPageNumber]: transformedOrders }
            setOrders(finalResult);
            setOrdersData(data.orders);
            setPaginationDetForOrders({ ...paginationDetForOrders, page: finalPageNumber, count: data?.total });
            message.success("Orders fetched successfully!");

        } catch (error) {
            setError("Failed to fetch orders. Please try again later.");
            message.error("Failed to fetch orders");
        } finally {
            setLoading(false);
        }
    };




    const fetchGearvuReportFromGHL = async () => {
        try {
            const { data } = await axiosApi.get('/reports/dashboard');
            const fetchedReports = data?.reports?.map((report) => {
                return {
                    reportId: report.data?.report?.reportid,
                    reportDate: report.data?.report?.finishtime,
                    sku: report.data?.report?.sku,
                    inStock: report?.data?.report?.inStock || 'Yes',
                    imei: report.data.report?.IMEI,
                    brand: report.data.report?.Manufacturer,
                    model: report.data.report?.Model || 'N/A',
                    value: report.data.report?.value,
                    status: report.data.report?.reportstatus,
                    grade: report.data.report?.grade,
                    ram: report.data.extra?.json?.DeviceInfo?.RAM,
                    storage: report.data.extra?.json?.DeviceInfo?.HandsetMemorySize

                }
            });

            setReports(fetchedReports);
            message.success("Reports fetched successfully!");
        } catch (error) {
            setError("Failed to fetch reports. Please try again later.");
            message.error("Failed to fetch Reports.");
        } finally {
            // setLoading(false);
        }


    }

    useEffect(() => {
        if (!products?.length && !orders?.length && !reports?.length && !catogoriesData.length) {
            fetchOrders();
            fetchGearvuReportFromGHL()
        }
    }, []);

    useEffect(() => {
        if (reports.length) {
            fetchProducts()
        }
    }, [reports])


    const save = async (newUpdatedOrder) => {
        setSaveLoading(true)
        try {
            // const { data } = await axios.post('http://gearvubackup.dymaxtech.com/api/woocommerce-order-update', {
            const { data } = await axiosApi?.post('/woocommerce-order-update', {
                updatedOrder: newUpdatedOrder?.orderPayload,
                emailData: newUpdatedOrder?.emailData
            })
            let order = data?.order;
            let transFrormedUpdatedOrder = {
                orderId: order.id || null,
                storeName: order?.store?.name || 'not found',
                productName: Array.isArray(order?.line_items) && order.line_items.length > 0 ? order.line_items[0]?.name || "" : "not found",
                customerName: `${order?.billing?.first_name || ''} ${order.billing.last_name || ''}`.trim() || null,
                customerEmail: order.billing.email || null,
                color: order.line_items?.map(item => item.color || 'N/A').join(", ") || null,
                reportLink: order.report_link || null,
                shippingAddress: `${order.shipping.address_1 || ''}, ${order.shipping.address_2 || ''}, ${order.shipping.city || ''}, ${order.shipping.state || ''}, ${order.shipping.postcode || ''}`.trim() || null,
                status: order.status || null,
                date_created: format(new Date(order.date_created), "MMMM dd, yyyy")

            }
            const transformedOrders = orders[paginationDetForOrders.page]?.map((order, index) => {
                if (order.orderId === data?.order?.id) {
                    return transFrormedUpdatedOrder
                } else {
                    return order
                }

            })
            let finalUpdatedOrders = paginationDetForOrders.page === 1 ? { [paginationDetForOrders.page]: transformedOrders } : { ...orders, [paginationDetForOrders.page]: transformedOrders }
            setOrders(finalUpdatedOrders)
            if (data.status === 'shipped' || data.status === 'refunded' || data.status === 'completed') {
                fetchGearvuReportFromGHL()
            }
            message.success("Order has been updated successfully!");


        } catch (errInfo) {
            message.error("Order could not update, try agin!");
            console.log("Validate Failed:", errInfo);
        } finally {
            setSaveLoading(false)
            setEditingKey(false)
        }
    };




    const columns = [
        { title: "Order ID", dataIndex: "orderId", ...getColumnSearchProps("orderId") },
        {
            title: "Date",
            dataIndex: "date_created",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
                <div style={{ padding: 8 }}>
                    <DatePicker
                        style={{ width: "100%" }}
                        value={selectedKeys[0] ? dayjs(selectedKeys[0]) : null} // Ensure proper date format
                        onChange={(date) => {
                            setSelectedKeys(date ? [date.toDate().toISOString()] : []); // Convert dayjs -> Date -> ISO
                            confirm();
                        }}
                        placeholder="Select Date"
                    />
                </div>
            ),
            onFilter: (value, record) => {
                // Ensure both values are valid Date objects
                const selectedDate = parseISO(value); // Convert stored ISO string back to Date
                const recordDate = new Date(record.date_created); // Ensure record is also a Date object
                return isSameDay(selectedDate, recordDate);
            },
            render: (date_created) => {
                return date_created ? format(new Date(date_created), "MMMM dd, yyyy") : "";
            }
        },

        { title: "Store Name", dataIndex: "storeName", ...getColumnSearchProps("storeName"), render: (text) => "Gearvana" },
        {
            title: "Product Name", dataIndex: "productName", ...getColumnSearchProps("productName")
            , render: (text) => (
                <Popover
                    content={<div style={{ maxWidth: "300px", whiteSpace: "normal" }}>{text}</div>}
                    title="Product Name"
                >
                    <span>{text?.length > 20 ? text.slice(0, 20) + "..." : text}</span>
                </Popover>
            )
        },
        { title: "Customer Name", dataIndex: "customerName", editable: true },
        { title: "Customer Email", dataIndex: "customerEmail", editable: true, width: 300 },
        {
            title: "Payment Status",
            dataIndex: "status",
            editable: true,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
                <Select

                    style={{ width: 180, borderColor: 'none' }}
                    placeholder="Select Status"
                    value={selectedKeys[0]}
                    onChange={(value) => {
                        setSelectedKeys(value ? [value] : []);
                        confirm();
                    }}
                    options={statusOptions.map(status => ({ label: status, value: status }))}
                />
            ),
            onFilter: (value, record) => record.status.includes(value),
            render: (status) => status || "N/A"
        },

        {
            title: "Edit",
            dataIndex: "edit",
            fixed: 'right',
            width: 70,
            render: (_, record) => {
                const editable = isEditing(record);
                return <Typography.Link onClick={() => edit(record)}>
                    Edit
                </Typography.Link>
            }
        },

    ];



    const OtherCategoriesColumns = [
        { title: "Product SKU", dataIndex: "sku", ...getColumnSearchProps("sku"), fixed: 'left', width: 110 },
        { title: "Category", dataIndex: "category", ...getColumnSearchProps("category"), width: 120 },

        {
            title: "Product Name",
            dataIndex: "productName",
            width: 110,
            ...getColumnSearchProps("productName"),
            render: (text) => (
                <Popover
                    content={<div style={{ maxWidth: "300px", whiteSpace: "normal" }}>{text || "N/A"}</div>}
                    title="Full Product Name"
                >
                    <span>{text?.length > 20 ? text.slice(0, 20) + "..." : text || "N/A"}</span>
                </Popover>
            )
        },
        {
            title: "Product Description",
            dataIndex: "description",
            width: 150,
            render: (text) => (
                <Popover
                    content={<div style={{ maxWidth: "400px", whiteSpace: "normal" }}>{text || "No Description"}</div>}
                    title="Full Description"
                >
                    <span>{text?.length > 32 ? text.slice(0, 32) + "..." : text || "N/A"}</span>
                </Popover>
            )
        },
        { title: "Brand", dataIndex: "brand", ...getColumnSearchProps("brand"), width: 100 },
        { title: "Regular Price", dataIndex: "regularPrice", key: "regularPrice", width: 100 },
        { title: "Sale Price", dataIndex: "salePrice", key: "salePrice", width: 100 },
        { title: "Stock Status", dataIndex: "stockStatus", key: "stockStatus", width: 100 },
        { title: "Stock Quantity", dataIndex: "stockQuantity", key: "stockQuantity", width: 110 },
        { title: "Condition", dataIndex: "condition", key: "condition", ...getColumnSearchProps("condition"), width: 100 }, // New, Used, Refurbished

        {
            title: "Link",
            dataIndex: "link",
            key: "link",
            width: 70,
            render: (text) => text !== "NA" ? <a href={text} target="_blank" rel="noopener noreferrer">View</a> : "N/A"
        },

        isCatogoryDevice && {
            title: "View Reports",
            dataIndex: "view",
            fixed: 'right',
            width: 100,
            render: (_, record) =>{ 
               return <Typography onClick={() => viewReprots(record)} style={{ cursor: "pointer", color: "#1890ff" }}>
                    View
                </Typography>
            }
        }
    ].filter(Boolean);

    const handleRefresh = () => {
        if (activeTab == 'orders') {
            setLoading(true);
            fetchOrders(0, { 'name': '' });
            setSearchTermForOrders({ 'name': '' })

        } else {
            setProductLoading(true);
            fetchGearvuReportFromGHL();
            fetchProducts(0, { 'name': '' });
            setSearchTermForProducts({ 'name': '' })
        }
    }

    const handleDateChange = (dates, dateStrings) => {
        setSearchTermForOrders({ 'date_created': dateStrings[0] && dateStrings[1] ? dateStrings : '' });
        fetchOrders(0, { 'date_created': dateStrings[0] && dateStrings[1] ? dateStrings : '' })
    };

    const renderHeaderForOrders = () => {
        return <div style={{ paddingTop: 20, paddingLeft: '10px', width: '98%', display: 'flex', justifyContent: 'space-between', marginRight: '10px', marginBottom: '10px', gap: 20 }}>
            {

                searchedColumn == 'date_created' ? <Flex style={{ justifyContent: 'center' }} ><DatePicker.RangePicker onChange={handleDateChange} format="YYYY-MM-DD" /></Flex> :

                    <Input.Search
                        style={{ width: '50%', minWidth: '200px', textAlign: 'left' }}
                        value={searchTermForOrders[searchedColumn || 'name']}
                        placeholder="Search"
                        enterButton={
                            <Button onClick={() => fetchOrders(0, searchTermForOrders)} type="primary" style={{ background: "#1677ff", color: "white" }}>Search</Button>
                        }
                        onPressEnter={(e) => fetchOrders(0, searchTermForOrders)}
                        onChange={(e) => setSearchTermForOrders({ [searchedColumn]: e.target.value })}

                    />
            }
            <Flex style={{ flex: 1 }}>

                <Select
                    defaultValue="name"
                    type="primary"
                    style={{ width: 200 }}
                    onChange={(value) => {
                        setSearchTermForOrders({ [value]: value })
                        setSearchedColumn(value)
                    }}
                >
                    {columnFieldMap.map((col) => (
                        <Select.Option key={col.value} value={col.value}>
                            {col.label}
                        </Select.Option>
                    ))}
                </Select>
            </Flex>
            <div style={{ display: 'flex', gap: '10px' }}>

                <Button loading={productLoading} onClick={() => setOpenNewOrder(true)} type="primary" style={{ background: "#1677ff", color: "white" }}>
                    {productLoading ? 'Loading Products' : 'Add new order'}
                </Button>
                <Button type="primary" style={{ background: "#1677ff", color: "white" }}>
                    Export
                </Button>
            </div>
        </div>
    }

    let isProductsLength = products[paginationDetForProducts.page] ? products[paginationDetForProducts.page]?.length : 0
    return (
        <div style={{ position: 'relative', padding: 15, paddingTop: 40, paddingBottom: 0 }}>
            {
                
                    <Spin size="large" spinning={loading} >
                            <div style={{  right: 20, margin: '10px', display: 'flex', justifyContent: 'flex-end', zIndex: 9999,marginRight:30 }}>
                                  <>
                                 <Button onClick={()=>SetIsSettingModel(true)}  type="primary" icon={<SettingOutlined />} style={{ background: "#1677ff", color: "white",marginRight:20 }} />
                                 <Button onClick={handleRefresh} type="primary" icon={<ReloadOutlined />} style={{ background: "#1677ff", color: "white",marginRight:20 }} />
                                 <LogoutButton />
                                 
                                  </>
                                 
                            </div>
                        <>
                            <SettingModal visible ={isSettingModel} onClose={SetIsSettingModel}  />
                            {isProductsLength ? <><AddNewOrderToWooCommerce isOpen={openNewOrder} onClose={setOpenNewOrder} products={rawProducts} fetchOrders={fetchOrders} /></> : null}
                            <ReportDataForDevices modalVisible={isViewKey} setModalVisible={setIsViewKey} reportData={matchedReports} getColumnSearchProps={getColumnSearchProps} />
                            {  <OrderEditModal orderToEdit={orderToEdit} isOpen={editingKey} onClose={setEditingKey} save={save} saveLoading={saveLoading} products={products} />}
                            {isProductsLength ? <CsvUploadModal visible={isCsvModal} onClose={setIsCsvModal} catogories={rowCatogories} /> : null}
                            {isProductsLength ?
                                <>
                                    <CsvUploadModal visible={isCsvModal} onClose={setIsCsvModal} catogories={rowCatogories} />
                                    <ExportProductsModal visible={isCsvExportModal} onClose={setIsCsvExportModal} categories={rowCatogories} products={rawProducts} />
                                </>
                                : null}

                            <Tabs defaultActiveKey={1} activeKey={activeTab} onChange={setActiveTab} style={{ background: "white", borderRadius: 8 }}>
                                <TabPane tab={
                                    <span style={{ fontWeight: "bold", paddingLeft: 10 }}> Orders
                                        {
                                            newOrdersCount != 0 && <Badge count={newOrdersCount || 0} offset={[-10, 0]} style={{ backgroundColor: 'red', }} >
                                                <BellTwoTone style={{ fontSize: 18 }} twoToneColor="red" />
                                            </Badge>
                                        }
                                    </span>} key="orders">

                                    <Form form={form} component={false} style={{ paddingTop: 100 }}>
                                        {renderHeaderForOrders()}

                                        <Flex style={{ height: '80vh', paddingTop: 10 }}>

                                            <Table
                                                className={styles.customTable}
                                                scroll={{ x: 'max-content', y: 700 }}
                                                tableLayout="fixed"
                                                components={{ body: { cell: EditableCell } }}
                                                bordered
                                                columns={columns}
                                                dataSource={orders[paginationDetForOrders.page]}
                                                rowClassName="editable-row"
                                                pagination={{
                                                    current: paginationDetForOrders.page,
                                                    total: paginationDetForOrders.count,
                                                    pageSize: 10,
                                                    onChange: (page) => {
                                                        fetchOrders(page, searchTermForOrders)
                                                    }
                                                }}

                                            />
                                        </Flex>
                                    </Form>
                                </TabPane>
                                <>

                                    <TabPane tab={<span onClick={() => setGlobalSearchVal('')} style={{ fontWeight: "bold" }}>Inventory</span>} key="inventory" >
                                        <Spin spinning={productLoading} size="large">

                                            <CategoryBaseProducts
                                                isCatogoryDevice={isCatogoryDevice}
                                                setIsCatogoryDevice={setIsCatogoryDevice}
                                                handleSearchFromSearchBar={(val) => handleSearchFromSearchBar(val)}
                                                setSlectedCaogory={setSlectedCaogory}
                                                setGlobalSearchVal={(val) => handleGlobalSearch(val)}
                                                setIsCsvModal={setIsCsvModal}
                                                setIsCsvExportModal={setIsCsvExportModal}
                                                setRowCatogories={setRowCatogories}
                                                setSearchTerm={setSearchTermForProducts}
                                                fetchProducts={fetchProducts}

                                            />
                                            <Flex >
                                                <Table
                                                    scroll={{ x: 'max-content', y: 720 }}
                                                    className={styles.customTable}
                                                    columns={OtherCategoriesColumns}
                                                    dataSource={catogoriesData?.length ? catogoriesData : products[paginationDetForProducts.page]}
                                                    tableLayout="fixed"
                                                    rowKey="id"
                                                    pagination={{
                                                        current: paginationDetForProducts.page,
                                                        total: paginationDetForProducts.count,
                                                        pageSize: 10,
                                                        onChange: (page) => {
                                                            fetchProducts(page, searchTermForProducts)
                                                        }
                                                    }}
                                                />
                                            </Flex>
                                        </Spin>
                                    </TabPane>
                                </>
                            </Tabs>
                        </>
                    </Spin>

            }
        </div >
    );
};




const ReportDataForDevices = ({ modalVisible, setModalVisible, reportData, getColumnSearchProps }) => {
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        message.success(`${text} copied!`);
    };
    const reportModalColumns = [
        {
            title: "Report ID",
            dataIndex: "reportId",
            key: "reportId",
            width: 160,
            fixed: "left",
            render: (text) => (
                <>
                    {text}
                    <Button
                        type="link"
                        icon={<CopyOutlined />}
                        onClick={() => copyToClipboard(text)}
                        style={{ marginLeft: 5 }}
                    />
                </>
            )
        },
        { title: "Report Date", dataIndex: "reportDate", key: "reportDate", width: 140 },
        {
            title: "IMEI",
            dataIndex: "imei",
            key: "imei",
            width: 200,
            ...getColumnSearchProps("imei"),
            render: (text) => (
                <>
                    {text}
                    <Button
                        type="link"
                        icon={<CopyOutlined />}
                        onClick={() => copyToClipboard(text)}
                        style={{ marginLeft: 5 }}
                    />
                </>
            )
        },
        { title: "Brand", dataIndex: "brand", ...getColumnSearchProps("brand"), width: 90 },
        { title: "Model", dataIndex: "model", ...getColumnSearchProps("model"), width: 120 },
        { title: "Status", dataIndex: "status", width: 120 },
        { title: "Grade", dataIndex: "grade", width: 90 },
        { title: "Memory", dataIndex: "ram", width: 90 },
        { title: "Storage", dataIndex: "storage", width: 90 },
        {
            title: "Report Link",
            dataIndex: "reportLink",
            key: "reportLink",
            width: 180,
            fixed: "right",
            render: (text) => (
                <Typography.Link href={text} target="_blank">
                    {text.slice(0, 20)}
                </Typography.Link>
            )
        }
    ];

    return (
        <Modal
            title="Device Report Details"
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={null}
            width={1000}
        >
            <Table
                columns={reportModalColumns}
                dataSource={reportData || []}
                rowKey="reportId"
                pagination={{ pageSize: 10 }}
                scroll={{ x: 1200 }}
            />
        </Modal>
    );
};

export default CustomPage;


















// function margeGearVuReportsWithWooCommerceDeviceCatogory(deviceCatogoryData) {
//     let result = deviceCatogoryData.map((product, index) => {
//         const matchingReport = reports.find((report, ind) => {
//             console.log('asdflkjasdflk', report, report?.sku === product?.sku)
//             return report?.sku === product?.sku
//         });

//         // console.log('asdflkjasdflk', product)
//         let catoroy = product?.categories?.find((item => item?.name === 'Devices'))
//         return {
//             // sku: product.sku || 'N/A',
//             // category: catoroy?.name,
//             // productName: product.productName,
//             // variationName: product?.variationName,
//             // description: product?.description?.replace(/<\/?[^>]+(>|$)/g, ""), // Remove HTML tags
//             // stockQuantity: product?.stock_quantity || 'N/A',
//             reportId: matchingReport?.reportId || "N/A",
//             reportDate: matchingReport?.reportDate || "N/A",
//             imei: matchingReport?.imei || "N/A",
//             brand: matchingReport?.brand || "N/A",
//             model: matchingReport?.model || product?.name,
//             os: matchingReport?.os || "N/A",
//             operator: matchingReport?.repor?.operator || "N/A",
//             value: product?.value || "N/A",
//             status: matchingReport ? "In stock" : "Out of stock",
//             grade: matchingReport?.grade || "N/A",
//             ram: matchingReport?.ram || "N/A",
//             storage: product?.attributes?.find(attr => attr.name === "Capacity")?.options?.join(", ") || product?.attributes?.find(attr => attr.name === "Capacity").option || "N/A"

//         };
//     });
//     setCatogoriesData(result)
// }


// const reportColumns = [
//     { title: "Product SKU", dataIndex: "sku", ...getColumnSearchProps("sku"), fixed: 'left', width: 110 },
//     { title: "Category", dataIndex: "category", ...getColumnSearchProps("category"), width: 120 },

//     {
//         title: "Product Name",
//         dataIndex: "productName",
//         width: 110,
//         ...getColumnSearchProps("productName"),
//         render: (text) => (
//             <Popover
//                 content={<div style={{ maxWidth: "300px", whiteSpace: "normal" }}>{text}</div>}
//                 title="Full Product Name"
//             >
//                 <span>{text?.length > 20 ? text.slice(0, 20) + "..." : text}</span>
//             </Popover>
//         )
//     },
//     {
//         title: "Product Description",
//         dataIndex: "description",
//         width: 150,
//         render: (text) => (
//             <Popover
//                 content={<div style={{ maxWidth: "400px", whiteSpace: "normal" }}>{text}</div>}
//                 title="Full Description"
//             >
//                 <span>{text.length > 32 ? text.slice(0, 32) + "..." : text}</span>
//             </Popover>
//         )
//     },
//     { title: "Brand", dataIndex: "brand", ...getColumnSearchProps("brand"), width: 100 },
//     { title: "Regular Price", dataIndex: "regularPrice", key: "regularPrice", width: 100 },
//     { title: "Sale Price", dataIndex: "salePrice", key: "salePrice", width: 100 },
//     { title: "Stock Status", dataIndex: "stockStatus", key: "stockStatus", width: 100 },
//     { title: "Stock Quantity", dataIndex: "stockQuantity", key: "stockQuantity", width: 110 },
//     { title: "Condition", dataIndex: "condition", key: "condition", width: 100 }, // New, Used, Refurbished

//     {
//         title: "Link",
//         dataIndex: "link",
//         key: "link",
//         fixed: 'left',
//         width: 70,
//         render: (text) => text !== "NA" ? <a href={text} target="_blank" rel="noopener noreferrer">View</a> : "N/A"
//     },


// ];


// const importCSVData = (file) => {
//     return new Promise((resolve, reject) => {
//         if (!file) {
//             return reject("No file provided.");
//         }

//         if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
//             return reject("Invalid file type. Please upload a CSV file.");
//         }

//         const reader = new FileReader();
//         reader.onload = (event) => {
//             const text = event.target.result;
//             const workbook = XLSX.read(text, { type: "string" });
//             const sheetName = workbook.SheetNames[0];
//             const sheet = workbook.Sheets[sheetName];
//             const jsonData = XLSX.utils.sheet_to_json(sheet);

//             const transformedData = jsonData.map((product) => ({
//                 categories: product.categories || "NA",
//                 key: product.id || "NA", // For table row keys
//                 productName: product.name || "NA",
//                 sku: product.sku || "NA",
//                 description: product.description
//                     ? product.description.replace(/</?[^>]+(>|$)/g, "")
//                     : "NA",
//                 brand: product.brands && product.brands.length > 0 ? product.brands[0].name : "NA",
//                 regularPrice: product.regular_price || "NA",
//                 salePrice: product.sale_price || "NA",
//                 stockStatus: product?.gr_stock_status || "NA",
//                 condition: "New", // Assuming "New", modify if necessary
//                 category: product.categories && product.categories.length > 0 ? product.categories[0].name : "NA",
//                 link: product.permalink || "NA",
//             }));

//             // resolve(transformedData);
//         };

//         reader.onerror = () => {
//             reject("Error reading the file.");
//         };

//         reader.readAsText(file);
//     });
// };
